import React from 'react';
import PropTypes from 'prop-types';

import CircleHeart from 'public/icons/profile/favorite.svg';
import HeartIcon from 'public/icons/profile/heart.svg';

const FollowIcon = ({ following, handleFollow, handleUnfollow, circleHeart }) => {
  if (following) {
    return circleHeart ? (
      <div className="circle-heart-img">
        <CircleHeart
          width={25}
          height={25}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            handleUnfollow();
          }}
          alt="Heart in Circle"
        />
      </div>
    ) : (
      <HeartIcon
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          handleUnfollow();
        }}
        className="g-fill-white"
        width={22}
        height={22}
        alt="Heart"
      />
    );
  }

  return circleHeart ? (
    <div className="circle-heart-img">
      <CircleHeart
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          handleFollow();
        }}
        width={25}
        height={25}
        className="circle-fill-grey"
        alt="Heart in Circle"
      />
    </div>
  ) : (
    <HeartIcon
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        handleFollow();
      }}
      width={22}
      height={22}
      alt="Heart"
    />
  );
};

FollowIcon.propTypes = {
  handleFollow: PropTypes.func.isRequired,
  handleUnfollow: PropTypes.func.isRequired,
  circleHeart: PropTypes.bool,
  following: PropTypes.bool,
};

FollowIcon.defaultProps = {
  following: false,
  circleHeart: false,
};

export default FollowIcon;
